import { graphql } from '~/lib/graphql'

export const ValidateShiftJis = graphql(/* GraphQL */ `
  query ValidateShiftJis($input: String!) {
    shiftJis(input: $input) {
      __typename
      ... on ShiftJisOk {
        bytesLen
      }
      ... on ShiftJisError {
        unmappableCharacter
      }
    }
  }
`)

export type ValidationStatus =
  | { status: 'unchecked' }
  | { status: 'valid'; bytesLen: number }
  | { status: 'invalid'; unmappableCharacter: string }

export function errorMessage(
  subject: string,
  status: ValidationStatus,
  options?: { min?: number; max?: number }
): string {
  if (status.status === 'invalid') {
    return `${subject}に使用できない文字が含まれています: ${status.unmappableCharacter}`
  }
  if (status.status === 'valid') {
    if (options?.min !== undefined && status.bytesLen < options.min) {
      return `${subject}が短すぎます`
    }
    if (options?.max !== undefined && status.bytesLen > options.max) {
      return `${subject}が長すぎます`
    }
  }
  return ''
}
